module.exports = __webpack_public_path__ + "media/images/indicators/escorregamento-347dfc1f57948558bb6368bafa23d7c1.png";